<template>
  <div>
    <CountHeader header="ตรวจสอบการนับสต๊อก" :img_header="header_image" link_back="count_stock/historylist"/>
    <Count_Close/>
  </div>
</template>

<script>
import HeaderImage from '@/assets/checklist_1.png'
import CountHeader from "@/components/admin/count_stock/headercount_stock/CountHeader.vue";
import Count_Close from "@/components/admin/count_stock/Count_Close.vue";
export default {
  name: "CountClose",
  components: {
    Count_Close,
    CountHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
